module.exports = __webpack_public_path__ + "28725df0921af00eea126086e8051454.svg";